import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readAllByEmisor: emisor =>
    api
      .send({
        query: gql`
          query READ_ALL($emisor: ID!) {
            Zone {
              readAllByEmisor(emisor: $emisor) {
                _id
                name
                number
                location
                state
                restaurant {
                  _id
                }
                table {
                  _id
                  name
                  state
                  number
                  seats
                  isAvailable
                }
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Zone.readAllByEmisor),

  create: input =>
    api
      .send({
        query: gql`
          mutation CREATE($input: ZoneInput!) {
            Zone {
              create(input: $input) {
                _id
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Zone.create),

  delete: input =>
    api
      .send({
        query: gql`
          mutation delete($input: [ID!]!) {
            Zone {
              delete(input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { input }
      })
      .then(result => result.data.data.Zone.delete)
}
